import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function PageNotFound() {
  const location = useLocation();

  // Prevent search engines from indexing 404 pages
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'noindex, nofollow');

    return () => {
      // Restore default indexing when leaving the 404 page
      if (meta) meta.setAttribute('content', 'index, follow');
    };
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24 bg-navy">
      <div className="max-w-md w-full text-center">
        <h1 className="mono-number text-white" style={{ fontSize: 'clamp(5rem, 18vw, 8rem)' }}>
          404
        </h1>
        <div className="h-0.5 w-16 bg-orange mx-auto mb-8" />
        <h2 className="text-2xl font-semibold text-white mb-3">
          Page Not Found
        </h2>
        <p className="text-sm text-white/70 leading-relaxed mb-10">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-orange text-navy text-sm font-semibold rounded-full hover:bg-orange-dark transition-colors"
          >
            <Home size={16} /> Back to Home
          </Link>
          <Link
            to="/services"
            className="inline-flex items-center justify-center px-8 py-3 border border-white/30 text-white text-sm font-semibold rounded-full hover:border-white transition-colors"
          >
            View Services
          </Link>
        </div>
      </div>
    </div>
  );
}